import { drawCategoryTypeIds, drawEliminationTypeIds, playOffDrawDetails } from '../../../utils/eventConstants';
import { isDrawMainOrQualifying, isDrawMainOrQualifyingOrCompassEast } from '../../../utils/events';

export const shouldDrawSizeBeDisabled = (isInEditMode, values, draw, parentDraw) => {
    const { eliminationTypeId } = values;
    if (isInEditMode) {
        const isGroupDraw = parentDraw?.categoryTypeId === drawCategoryTypeIds.GROUPED;

        const arePlayOffDrawsEnabled = playOffDrawDetails.reduce((acc, playOffDrawDetail) => {
            if (!acc) {
                return values[playOffDrawDetail.fieldName];
            }

            return acc;
        }, false);

        return isGroupDraw ||
            !isDrawMainOrQualifying(draw.categoryTypeId) ||
            arePlayOffDrawsEnabled ||
            values.createPlayoffBronzeMatch ||
            parseInt(eliminationTypeId) === drawEliminationTypeIds.FEED_IN_CONSOLATION ||
            parseInt(eliminationTypeId) === drawEliminationTypeIds.DOUBLE_ELIMINATION;
    }

    return false;
};

export const shouldDrawNameFieldBeDisabled = (isInEditMode, values, parentDraw) => {
    if (isInEditMode) {
        if (parseInt(values.eliminationTypeId) === drawEliminationTypeIds.PRO_DRAWS) {
            return false;
        }

        if (parseInt(values.categoryTypeId) === drawCategoryTypeIds.GROUPED) {
            return false;
        }

        const hasGroupDrawParent = parentDraw?.categoryTypeId === drawCategoryTypeIds.GROUPED;
        return !isDrawMainOrQualifyingOrCompassEast(values.categoryTypeId) && !hasGroupDrawParent;
    }

    return false;
};

export const shouldDisplayPlayOffDrawSection = (isInEditMode, parentDraw, drawToEdit) => {
    if (isInEditMode && parentDraw) {
        return parentDraw.id === drawToEdit?.id;
    }

    return true;
};

export const needsPlayersAdvancingToPlayoff = (eliminationTypeId) => {
    return parseInt(eliminationTypeId) === drawEliminationTypeIds.ROUND_ROBIN ||
        parseInt(eliminationTypeId) === drawEliminationTypeIds.AD_HOC;
};

export const getMaxPlayersAllowedForPlayoff = (eliminationTypeId, drawSize, matchesPerRound) => {
    if (parseInt(eliminationTypeId) === drawEliminationTypeIds.AD_HOC) {
        const playersInvolved = parseInt(matchesPerRound) * 2;
        return 2 ** Math.ceil(Math.log2(playersInvolved));
    }

    return parseInt(drawSize);
};
